export const EXAM_INFO = {
  "level": "B2",
  "name": "Goethe-Zertifikat B2",
  "source": "Modellsatz Erwachsene (Goethe-Institut 2018)",
  "sourceUrl": "https://www.goethe.de/pro/relaunch/prf/materialien/B2/b2_modellsatz_erwachsene.pdf",
  "passScore": 60,
  "maxScore": 100,
  "description": "Modellsatz zyrtar Goethe B2 për të rritur — katër module: Lesen (5 pjesë), Hören (4 pjesë), Schreiben (2 pjesë), Sprechen (2 pjesë)."
};
export const SKILLS = [
  {
    "id": "lesen",
    "title": "Lesen",
    "subtitle": "Leximi",
    "duration": "65 min",
    "parts": 5,
    "path": "/exam/b2/lesen",
    "color": "blue",
    "description": "Forum, artikuj, komente, rregulla — 5 pjesë sipas Modellsatzit."
  },
  {
    "id": "hoeren",
    "title": "Hören",
    "subtitle": "Dëgjimi",
    "duration": "40 min",
    "parts": 4,
    "path": "/exam/b2/hoeren",
    "color": "purple",
    "description": "Biseda, intervista, raporte radiofonike, ligjëratë — 4 pjesë."
  },
  {
    "id": "schreiben",
    "title": "Schreiben",
    "subtitle": "Shkrimi",
    "duration": "75 min",
    "parts": 2,
    "path": "/exam/b2/schreiben",
    "color": "green",
    "description": "Forumsbeitrag (min. 150 fjalë) + Nachricht an Vorgesetzten (min. 100 fjalë)."
  },
  {
    "id": "sprechen",
    "title": "Sprechen",
    "subtitle": "Folësimi",
    "duration": "15 min (+15 min prep)",
    "parts": 2,
    "path": "/exam/b2/sprechen",
    "color": "orange",
    "description": "Vortrag (~4 min) + Diskussion: Sollen Studierende ihre Professoren beurteilen?"
  }
];
export { LESEN_TASKS } from './lesen';
export { HOEREN_TASKS } from './hoeren';
export { SCHREIBEN_TASKS } from './schreiben';
export { SPRECHEN_TASKS, REDEMITTEL } from './sprechen';
